// extracted by mini-css-extract-plugin
module.exports = {"rowStyle":"PofEditPage_rowStyle__3ykl7","sum":"PofEditPage_sum__3Plun","inputStyle":"PofEditPage_inputStyle__dfmN2","info":"PofEditPage_info__1T9Zx"};